// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import common from './model/common.js';
Vue.prototype.$common = common
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

axios.defaults.baseURL = '/tbbh'//改成/api才能用proxyTable跨域
// axios.defaults.baseURL = 'http://ceshi1.diemingcar.com/tbbh'
// axios.defaults.baseURL = 'http://www.bjcdzbh.com/tbbh'

Vue.prototype.$http = axios

// 全局监听sessionStorage的变化

Vue.prototype.resetSetItem = function (key, newVal) {

      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);

              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
}

Vue.prototype.resetRemoveItem = function (key, newVal) {

  // 创建一个StorageEvent事件
  var newStorageEvent = document.createEvent('StorageEvent');
  const storage = {
    removeItem: function (k, val) {
          sessionStorage.removeItem(k, val);

          // 初始化创建的事件
          newStorageEvent.initStorageEvent('removeItem', false, false, k, null, val, null, null);

          // 派发对象
          window.dispatchEvent(newStorageEvent)
      }
  }
  return storage.removeItem(key, newVal);
}


Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.filter("ellipsis",(value)=>{
  if (!value) return ''
  if (value.length > 260) {
    return value.slice(0,260) + '...'
  }
  return value
})

Vue.filter("ellipsis76",(value)=>{
  if (!value) return ''
  if (value.length > 76) {
    return value.slice(0,76) + '...'
  }
  return value
})

Vue.filter("formatData",(value)=>{
  if (!value) return ''
  if (value.length > 10) {
    return value.slice(0,10) 
  }
  return value
})

Vue.use(ElementUI);

let vueThis = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
export default vueThis



// WEBPACK FOOTER //
// ./src/main.js